import api from "../index";

// ** --------- AI App API --------- ** //
// Create a ai-app
export const createAiApp = (values: any) => {
  return api.post("/ai-app", values);
};

// Get all ai-apps
export const getAllAiApps = () => {
  return api.get("/ai-apps");
};

// Get all ai-apps paginated search
export const getAllAiAppsPaginatedSearch = async (
  page: any,
  perPage: any,
  searchText: any
) => {
  if (!searchText) {
    return await api.get(
      `/ai-apps/paginated/search?page=${page}&perPage=${perPage}`
    );
  } else {
    return await api.get(
      `/ai-apps/paginated/search?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get a ai-app by ID
export const getAiAppById = (id: any) => {
  return api.get(`/ai-app/${id}`);
};

// Update a ai-app by ID
export const updateAiAppById = (id: any, values: any) => {
  return api.put(`/ai-app/${id}`, values);
};

// Delete a ai-app by ID
export const deleteAiAppById = (id: any) => {
  return api.delete(`/ai-app/${id}`);
};

// Upload ai-app cover image
export const uploadAiAppCoverImage = async (values: any, config: any) => {
  return await api.post(`/ai-app/cover-image`, values, config);
};

// Upload ai-app content image
export const uploadAiAppContentImage = async (values: any, config: any) => {
  return await api.post(`/ai-app/content-image`, values, config);
};

// Update ai-app approval by ID
export const updateAiAppApprovalById = async (id: any, values: any) => {
  return await api.put(`/ai-app/approve/${id}`, values);
};

// ** --------- AI App Category API --------- ** //
// Create a ai-app Category
export const createAiAppCategory = async (values: any) => {
  return await api.post("/ai-app-category", values);
};

// Get all ai-app Categories
export const getAllAiAppCategories = async () => {
  return await api.get(`/ai-app-categories`);
};

// Get all ai-apps paginated search
export const getAllAiAppsCategoriesPaginatedSearch = async (
  page: any,
  perPage: any,
  searchText: any
) => {
  if (!searchText) {
    return await api.get(
      `/ai-app-categories/paginated/search?page=${page}&perPage=${perPage}`
    );
  } else {
    return await api.get(
      `/ai-app-categories/paginated/search?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get a ai-app Category by id
export const getAiAppCategoryById = async (id: any) => {
  return await api.get(`/ai-app-category/${id}`);
};

// Update a ai-app Category by id
export const updateAiAppCategoryById = async (id: any, values: any) => {
  return await api.put(`/ai-app-category/${id}`, values);
};

// Delete a ai-app Category by id
export const deleteAiAppCategoryById = async (id: any) => {
  return await api.delete(`/ai-app-category/${id}`);
};
